const tableWrapper = document.getElementsByClassName("table-wrapper")[0];
let currentOrder;
let adminCategories = [];
let tabName;
let adminStore = [];
let orders = [];
let shippings = [];
let users;
let filter;
let search;

const getAvailable = (qt) => {
    let available = 'no';
    if (qt > 0) {
       available = 'si'
    }
    return available
}

const changeAvailables = (size,id,el) => {
    const sizeAvailableRef = database.ref('/products/' + id + '/sizes/' + size + '/')
    sizeAvailableRef.set($(el).val());
}

if ( page === 'admin' ){
    if (getParameterByName('section',window.location) !== undefined &&
        getParameterByName('section',window.location) !== null){
        tabName = getParameterByName('section', window.location.href);
        $('*[data-item="' + tabName + '"]').addClass('active');
    } else {
        window.history.pushState(null, null, 'index.php?section=orders')
        tabName = 'orders';
        $('*[data-item="orders"]').addClass('active');
    }

    const getProducts = (withTable) => {
        database.ref('products').orderByKey().on('value', (productsShot) => {
            const productsValue = productsShot.val()
            products = productsValue;
            let productsKeys = Object.keys(products);
            let counter = 0;
            productsKeys.forEach((key,index) => {
                products[key].id = key;
            })
            products = Object.values(products).reverse();
            var productsLoaded = new Event('productsLoaded');
            document.dispatchEvent(productsLoaded)
        })

    }
    const getOrders = (withTable) => {
        database.ref('/orders/').on('value', ordersShot => {
            const ordersValue = ordersShot.val()
            let ordersKeys = Object.keys(ordersValue)
            ordersKeys.forEach(key => {
                ordersValue[key].sku = key;
                ordersValue[key].id = key;
            })
            orders = Object.values(ordersValue)
            var ordersLoaded = new Event('ordersLoaded');
            document.dispatchEvent(ordersLoaded)
        })
    }
    const getStore = (withTable) => {
        database.ref('/products/').orderByKey().on('value', (productsShot) => {
            adminStore = [];
            let store = productsShot.val();
            let storeKeys = Object.keys(store);
            storeKeys.forEach((key,index) => {
                let newKey;
                let productSizes = store[key].sizes;
                let itemUrl;
                if (productSizes !== undefined){
                    let productSizesKeys = Object.keys(productSizes)
                    let coverRef = storage.ref('/images/products/' + key + '/cover.jpg')
                    productSizesKeys.forEach(sizeKey => {
                        adminStore.push({
                            id: key,
                            preview : itemUrl,
                            name: store[key].title,
                            category: store[key].category,
                            subCategory: store[key].subCategory,
                            size: sizeKey,
                            qt: productSizes[sizeKey],
                            img : store[key].img,
                            available : getAvailable(productSizes[sizeKey])
                        })
                    })
                    var storeLoaded = new Event('storeLoaded');
                    document.dispatchEvent(storeLoaded)
                }
            })
        })
    }
    const getCategories = (withTable) => {
        adminCategories = [];

        categoriesRef.once('value', (productsShot) => {
            let categories = productsShot.val()
            if (categories !== undefined && categories !== null){
                let categoriesKeys = Object.keys(categories);
                categoriesKeys.forEach(key => {
                    adminCategories.push({
                        name : key,
                        parent : false,
                        sizeType : categories[key].sizeType
                    })
                    let adminSubcategories = Object.values(categories[key].subCategories);
                    adminSubcategories.forEach(subCat => {
                        adminCategories.push({
                            name : '---' + subCat,
                            parent : key,
                            sizeType : categories[key].sizeType
                        })
                    })
                })
                var categoriesLoaded = new Event('categoriesLoaded');
                document.dispatchEvent(categoriesLoaded)
            }
        })
    }

    const getUsers = (withTable) => {
        database.ref('/usersTable/').on('value', usersShot => {
            const usersValue = usersShot.val()
            let usersKeys = Object.keys(usersValue)
            usersKeys.forEach(key => {
                usersValue[key].uid = key
            })
            users = Object.values(usersValue)
            var usersLoaded = new Event('usersLoaded');
            document.dispatchEvent(usersLoaded)
        })
        var usersLoaded = new Event('usersLoaded');
        document.dispatchEvent(usersLoaded)
    }
    const getShippings = (withTable) => {
        database.ref('/shippings/').on('value', shippingsShot => {
            const shippingsValue = shippingsShot.val()
            let shippingsKeys = Object.keys(shippingsValue)
            shippingsKeys.forEach(key => {
                shippingsValue[key].id = key
            })
            shippings = Object.values(shippingsValue)
            var shippingsLoaded = new Event('shippingsLoaded');
            document.dispatchEvent(shippingsLoaded)
        })
    }
    const goToSection = (tab) => {
        window.location = '/admin/index.php?section=' + tab
    }

    $(`.${tabName}-toolbar`).removeClass('d-none');

    switch (tabName) {
        case "products":
            let getProductStatus = (item) => {
                let status;
                if (item.public){
                    status = '<small><i class="fa fa-circle text-green"></i></small> Pubblico'
                } else {
                    status = '<small><i class="fa fa-circle text-red"></i></small> Bozza'
                }
                return status
            }

            filter = {
                value: false,
                prop: "status"
            };
            search = {
                value: false,
                props: "name"
            };
            //richiedo i dati
            getProducts(true);
            //creo la tabella
            document.addEventListener("productsLoaded", function() {
                vlkTabler(products, productModel, tableWrapper, paginationSetting, filter);
            });
            break;
        case "store":
            //creo la tabella
            filter = {
                value: false,
                prop: "state"
            };
            search = {
                value: false,
                props: "id"
            };

            getStore(false);

            document.addEventListener("storeLoaded", function() {
                vlkTabler(adminStore, storeModel, tableWrapper, paginationSetting, filter);
            });
            //metodi tabella prodotti
            break;
        case "orders":

            filter = {
                value: false,
                prop: "status"
            };
            search = {
                value: false,
                props: "id"
            };

            getOrders(true);

            document.addEventListener("ordersLoaded", function() {
                vlkTabler(orders, orderModel, tableWrapper, paginationSetting, filter);
            });
            //metodi tabella prodotti
            break;

        case "shippings":
            //definisco valori default per filtri e campo di ricerca
            filter = {
                value: false,
                prop: "name"
            };
            search = {
                value: false,
                props: "name"
            };
            //richiedo i dati
            getShippings(true);
            //creo la tabella
            document.addEventListener("shippingsLoaded", function() {
                vlkTabler(shippings, shippingModel, tableWrapper, paginationSetting, filter);
            });

            break;
        case "categories":
            filter = {
                value: false,
                prop: "status"
            };
            search = {
                value: false,
                props: "name"
            };
            getCategories(true);
            document.addEventListener("categoriesLoaded", function() {
                vlkTabler(adminCategories, categoriesModel, tableWrapper, paginationSetting, filter);
            });
            //metodi tabella prodotti
            break;

        case "users":
            filter = {
                value: false,
                prop: "status"
            };
            search = {
                value: false,
                props: "email"
            };
            getUsers(true)
            document.addEventListener("usersLoaded", function() {
                vlkTabler(users, userModel, tableWrapper, paginationSetting, filter);
            });
            break;
        default:
    }
}
